// Screenname:Account Head master
// Developer Name: Tharuni.
// Created date on: 7 / 5 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages:
import httpbaseURL from "../common/axios";
class AccountHeadservices {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AccountHeadMAS/Create", doc);
  }
  getdata(HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AccountHeadMAS/List?HospitalId=" + HospitalId
    );
  }
  getfindonedata(doc, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AccountHeadMAS/Get?id=" + doc + "&HospitalId=" + HospitalId
    );
  }
  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AccountHeadMAS/Update", doc);
  }
  deletedata(doc, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/AccountHeadMAS/Delete?id=" + doc + "&HospitalId=" + HospitalId
    );
  }
  active(DelID, Status, HospitalId) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.put(
      "AccountHeadMAS/Active?id=" +
        DelID +
        "&Status=" +
        Status +
        "&HospitalId=" +
        HospitalId +
        ""
    );
  }

  getNatureOfGroupList() {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AccountHeadMAS/NatureOfGroupList"
    );
  }

  getReportCategoryList() {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AccountHeadMAS/ReportCategoryList"
    );
  }
  getHeadsByOrganizationId(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AccountHeadMAS/GetAccHeadListByOrganizationId?HospitalId=" + doc
    );
  }
}
export default new AccountHeadservices();
